import {FC} from 'react'
import clsx from 'clsx'
import {useIntl} from 'react-intl'

type StatusCellProps = {
  status: string
}

const SponsorshipStatusCell: FC<StatusCellProps> = ({status}) => {
  const intl = useIntl()

  return (
    <div className={clsx('badge', {
      'badge-light-primary': status === 'STATUS_PENDING',
      'badge-light-success': status === 'STATUS_APPROVED',
      'badge-light-danger': status === 'STATUS_REJECTED'
    })}>
      {intl.formatMessage({id: `P2C.SPONSORSHIP_${status}`})}
    </div>
  )
}

type PrcCellProps = {
  value: number
}

const SponsorshipPrcCell: FC<PrcCellProps> = ({value}) => {
  const intl = useIntl()

  return (
    <>
      {intl.formatNumber(value, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}%
    </>
  )
}

export {
  SponsorshipStatusCell,
  SponsorshipPrcCell,
}
